<template>
  <div class="enter-code">
    <div class="ri-large-body margin-top-xxs">
      <div>
        שלחנו לך
        <span class="ri-font-weight-bold">קוד ל WhatsApp </span>
        למספר
      </div>
      <div>{{ phoneNumber }}</div>
    </div>

    <text-input
      class="margin-top-l"
      :autofocus="true"
      :label-text="'קוד חד פעמי'"
      :value="code"
      :on-input="onInput"
      :input-pattern="'\\d*'"
      :error="!!serverError"
      :top-left-label="serverError"
      input-type="number"
      autocomplete="one-time-code"
    />

    <riseup-button
      class="hug-button"
      :title="buttonTitle"
      :action="() => confirmCodeAction(code)"
      :loading="loading"
      :disabled="disableConfirmCode"
    />
    <div
      class="action"
      @click="resendCode"
    >
      לא קיבלתי את הקוד, שלחו לי שוב
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import RiseupButton from '@riseupil/base-ui/src/components/RiseupButton/RiseupButton.vue';
import TextInput from '@riseupil/base-ui/src/components/Inputs/TextInput.vue';
import Segment from '../../Segment';

interface Props {
  phoneNumber: string;
  confirmCodeAction(code: string): void;
  regenerateCodeAction(): void;
  serverError: string;
  resetError(): void;
  buttonTitle: string;
  loading?: boolean;
}

function resendCode() {
  Segment.trackUserInteraction('EnterCode_ResendCodeClicked');
  props.regenerateCodeAction();
}

const props = withDefaults(
  defineProps<Props>(),
  { loading: false },
);
const triedAutoConfirm = ref(false);
const code = ref('');

const disableConfirmCode = computed(() => code.value.length !== 6 || props.loading);

const onInput = (value: string) => {
  props.resetError();
  code.value = value;
  if (!triedAutoConfirm.value && code.value.length === 6) {
    triedAutoConfirm.value = true;
    props.confirmCodeAction(code.value);
  }
};
</script>

<style lang="scss" scoped>
  @import 'base-ui-vue3/src/scss/riseup-colors';
  @import '@riseupil/base-ui/src/scss/mixins';

  .enter-code {

    .title {
      padding: 20px 0px;
      font-family: SimplerProBold;
      font-size: 22px;
      line-height: 28px;
    }

    .riseup-button {
      width: 100%;
      margin: 10px 0px;
    }

    .action {
      margin: 20px 0px;
      color: $riseup_blue;
      font-weight: bold;
      cursor: pointer;
      font-size: 16px;
      text-align: center;
    }

    .loader {
      margin: 0 auto;
      width: 34px;
      height: 34px;
      border: 4px solid $riseup_blue;
      border-top: 4px solid $riseup_white;
      border-radius: 50%;
      animation: spin 2s linear infinite;

      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    }
    .hug-button {
      height: 58px;
    }
  }
</style>
